import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { TableHeadSortingCell } from './table_head_sorting_cell';
import { CountryFlag } from './country_flag';
import { capitalizeCountryName } from 'javascripts/analytics/utils/country_names';
import { trackAnalyticsClick } from 'js/analytics/metrics/analyticsTracking';

export class CountriesTable extends React.Component {
  static propTypes = {
    countries: PropTypes.array.isRequired,
    dayCount: PropTypes.number.isRequired,
  };

  state = {
    sortBy: 'thirtyDayViews',
    sortDirection: 'DESC',
    expandedCountries: [],
  };

  updateSort = (sortBy) => {
    return function () {
      trackAnalyticsClick('analytics-sort', {
        table: 'countries',
        column: sortBy,
      });
      this.setState({
        sortBy: sortBy,
        sortDirection: this.state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
      });
    }.bind(this);
  };

  render() {
    return (
      <table className="analytics-dashboard-data-table table table-bordered table-hover u-mb0x">
        <thead>
          <tr>
            <th className="col-xs-8">Country</th>

            <TableHeadSortingCell
              sortingByColumn={this.state.sortBy === 'thirtyDayViews'}
              sortDirection={this.state.sortDirection}
              onClick={this.updateSort('thirtyDayViews')}
              className="col-xs-2"
            >
              {this.props.dayCount}-day views
            </TableHeadSortingCell>
            <TableHeadSortingCell
              sortingByColumn={this.state.sortBy === 'allTimeViews'}
              sortDirection={this.state.sortDirection}
              onClick={this.updateSort('allTimeViews')}
              className="col-xs-2"
            >
              All-time views
            </TableHeadSortingCell>
          </tr>
        </thead>

        <tbody>
          {_.reduce(
            this.sortedCountries(),
            function (memo, country) {
              return memo.concat(
                [this.renderCountryRow(country)],
                this.renderCityRows(
                  country,
                  _.contains(this.state.expandedCountries, country.countryCode),
                ),
              );
            },
            [],
            this,
          )}
        </tbody>
      </table>
    );
  }

  nameForCountry = (country) => {
    return capitalizeCountryName(country.countryName);
  };

  expandIconForCountry = (country) => {
    // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
    // eslint-disable-next-line eqeqeq
    if (country.cities.length == 0) return '';

    if (_.contains(this.state.expandedCountries, country.countryCode)) {
      return 'fa-angle-down';
    } else {
      return 'fa-angle-right';
    }
  };

  renderCountryRow = (country) => {
    return (
      <tr key={'c-' + country.countryCode}>
        <td
          className="u-clickable"
          onClick={this.toggleCityRowsVisibility.bind(this, country)}
        >
          <CountryFlag country={country} />
          <span className="u-displayInlineBlock" style={{ width: '17px' }}>
            <i className={'fa ' + this.expandIconForCountry(country)}></i>
          </span>
          {this.nameForCountry(country)}
        </td>
        <td className="u-fontMonospaced u-fs12">
          {$h.commaizeInt(country.thirtyDayViews)}
        </td>
        <td className="u-fontMonospaced u-fs12">
          {$h.commaizeInt(_.result(country, 'allTimeViews'))}
        </td>
      </tr>
    );
  };

  renderCityRows = (country, shouldShow) => {
    return _.map(
      country.cities,
      function (city) {
        return (
          <tr
            key={country.countryCode + '-' + city.name}
            className={'city-row ' + (shouldShow ? '' : 'u-displayNone')}
          >
            <td className="u-pl16x u-fs12">{city.name}</td>
            <td className="u-fs12">{city.thirtyDayViews}</td>
          </tr>
        );
      },
      this,
    );
  };

  sortedCountries = () => {
    const countries = _.sortBy(
      this.props.countries,
      function (country) {
        return _.result(country, [this.state.sortBy]);
      },
      this,
    );

    if (this.state.sortDirection === 'ASC') return countries;

    return _.clone(countries).reverse();
  };

  toggleCityRowsVisibility = (country) => {
    const expanded = !_.contains(
      this.state.expandedCountries,
      country.countryCode,
    );
    trackAnalyticsClick('analytics-country-expand', {
      country: this.nameForCountry(country),
      expanded,
    });
    if (!expanded) {
      this.setState({
        expandedCountries: _.without(
          this.state.expandedCountries,
          country.countryCode,
        ),
      });
    } else {
      this.setState({
        expandedCountries: this.state.expandedCountries.concat([
          country.countryCode,
        ]),
      });
    }
  };
}
